export default __webpack_public_path__ + "static/media/badge.171c6150.png";